/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { isStayAdminNavHidden } from 'app/mock-api/common/navigation/stay-admin-nav.config';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard'
    },
    {
        id   : 'module.passengers',
        title: 'Passengers',
        type : 'basic',
        icon : 'heroicons_outline:identification',
        link : '/passengers/info'
    },
    {
        id   : 'module.bookings',
        title: 'Bookings',
        type : 'basic',
        icon : 'heroicons_outline:ticket',
        disabled: false,
        link : '/transactions/bookings'
    },
    {
        id   : 'module.stay-bookings',
        title: 'Stay Bookings',
        type : 'basic',
        icon : 'heroicons_outline:building-office',
        disabled: false,
        hidden : () => isStayAdminNavHidden(),
        link : '/travel/stay-bookings'
    },
    {
        id   : 'module.cancellation-requests',
        title: 'Cancellation Requests',
        type : 'basic',
        icon : 'heroicons_outline:inbox',
        disabled: false,
        hidden : () => isStayAdminNavHidden(),
        link : '/travel/cancellation-requests'
    },
    // {
    //     id   : 'module.customer',
    //     title: 'Customer Booking',
    //     type : 'basic',
    //     icon : 'heroicons_outline:star',
    //     disabled: false,
    //     link : '/customer/booking'
    // },
    {
        id   : 'module.accounting',
        title: 'Accounting',
        type : 'basic',
        icon : 'heroicons_outline:banknotes',
        disabled: false,
        link : '/accounting'
    },
    {
        id      : 'reports',
        title   : 'Reports',
        subtitle: 'Unveiling Finances Trends, Analysis, and Recommendations',
        type    : 'group',
        icon    : 'heroicons_outline:arrow-trending-up',
        children: [
            {
                id   : 'module.reports.purchase-orders',
                title: 'Sales',
                type : 'basic',
                icon : 'heroicons_outline:arrow-trending-up',
                link : '/reports/accounting/statement-of-accounts'
            },
            {
                id   : 'module.reports.purchase-orders',
                title: 'Purchase Orders',
                type : 'basic',
                icon : 'heroicons_outline:truck',
                link : '/reports/accounting/purchase-orders'
            },
            {
                id   : 'module.reports.audit-logs',
                title: 'Audit Logs',
                type : 'basic',
                icon : 'heroicons_outline:document-magnifying-glass',
                link : '/reports/audit-logs'
            },

        ],
    },
    {
        id      : 'database',
        title   : 'Databases',
        subtitle: 'Manage your databases',
        type    : 'group',
        icon    : 'heroicons_outline:circle-stack',
        children: [
            {
                id   : 'module.database.passengers',
                title: 'Passengers',
                type : 'basic',
                icon : 'mat_outline:contacts',
                link : '/database/passengers'
            },
            {
                id   : 'module.database.agents',
                title: 'Agents',
                type : 'basic',
                icon : 'mat_outline:badge',
                disabled: false,
                link : '/database/agents'
            },
            {
                id   : 'module.database.suppliers',
                title: 'Suppliers',
                type : 'basic',
                icon : 'heroicons_outline:truck',
                disabled: false,
                link : '/database/suppliers'
            },
            {
                id   : 'module.database.packages',
                title: 'Packages',
                type : 'basic',
                icon : 'heroicons_outline:shopping-bag',
                disabled: false,
                link : '/database/packages'
            },
        ],
    },
    {
        id      : 'cms',
        title   : 'Website',
        subtitle: 'Manage public website content and displays',
        type    : 'group',
        icon    : 'heroicons_outline:shield-check',
        children: [
            // {
            //     id   : 'administration.users',
            //     title: 'Flights',
            //     type : 'basic',
            //     icon : 'mat_outline:airplane_ticket',
            //     link : '/administration/users',
            // },
            // {
            //     id   : 'administration.users',
            //     title: 'Hotel',
            //     type : 'basic',
            //     icon : 'heroicons_outline:building-office-2',
            //     link : '/administration/users',
            // },
            {
                id   : 'cms.packages',
                title: 'Packages',
                type : 'basic',
                icon : 'heroicons_outline:photo',
                link : '/cms/packages',
            },
            {
                id   : 'cms.global-settings',
                title: 'Global Settings',
                type : 'basic',
                icon : 'heroicons_outline:globe-asia-australia',
                link : '/cms/global-settings',
            },
            
            
            // {
            //     id   : 'administration.roles',
            //     title: 'Roles',
            //     type : 'basic',
            //     icon : 'heroicons_outline:lock-closed',
            //     link : '/administration/roles',
            // },
            // {
            //     id   : 'administration.appSettings',
            //     title: 'App Settings',
            //     type : 'basic',
            //     icon : 'heroicons_outline:cog',
            //     link : '/administration/app-settings',
            // },
            // {
            //     id   : 'administration.systemLogs',
            //     title: 'System Logs',
            //     type : 'basic',
            //     icon : 'heroicons_outline:clipboard-document-check',
            //     link : '/administration/system-logs',
            // },
        ],
    },
    {
        id      : 'administration',
        title   : 'Administration Tools',
        subtitle: 'Manage this application',
        type    : 'group',
        icon    : 'heroicons_outline:shield-check',
        children: [

            {
                id   : 'administration.users',
                title: 'Users',
                type : 'basic',
                icon : 'heroicons_outline:user-group',
                link : '/administration/users',
            },
            {
                id   : 'administration.roles',
                title: 'Roles',
                type : 'basic',
                icon : 'heroicons_outline:lock-closed',
                link : '/administration/roles',
            },
            {
                id   : 'administration.appSettings',
                title: 'App Settings',
                type : 'basic',
                icon : 'heroicons_outline:cog',
                link : '/administration/app-settings',
            },
            {
                id   : 'administration.systemLogs',
                title: 'System Logs',
                type : 'basic',
                icon : 'heroicons_outline:clipboard-document-check',
                link : '/administration/system-logs',
            },
        ],
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard',
    },
    {
        id: 'module.passengers',
        title: 'Passengers',
        tooltip: 'Passengers',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link : '/transactions/bookings'
    },
    {
        id: 'module.bookings',
        title: 'Bookings',
        tooltip: 'Bookings',
        type: 'basic',
        icon: 'heroicons_outline:ticket',
        link : '/transactions/bookings'
    },
    {
        id: 'module.stay-bookings',
        title: 'Stay Bookings',
        tooltip: 'Stay Bookings',
        type: 'basic',
        icon: 'heroicons_outline:building-office',
        hidden : () => isStayAdminNavHidden(),
        link : '/travel/stay-bookings'
    },
    {
        id: 'module.cancellation-requests',
        title: 'Cancellation Requests',
        tooltip: 'Cancellation Requests',
        type: 'basic',
        icon: 'heroicons_outline:inbox',
        hidden : () => isStayAdminNavHidden(),
        link : '/travel/cancellation-requests'
    },
    {
        id   : 'module.accounting',
        title: 'Accounting',
        tooltip: 'Accounting',
        type : 'basic',
        icon : 'heroicons_outline:banknotes',
        disabled: false,
        link : '/accounting'
    },
    {
        id: 'reports',
        title: 'Reports',
        tooltip: 'Unveiling Finances Trends, Analysis, and Recommendations',
        type: 'aside',
        icon    : 'heroicons_outline:arrow-trending-up',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'database',
        title: 'Databases',
        tooltip: 'Databases',
        type: 'aside',
        icon: 'heroicons_outline:circle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'administration',
        title: 'Administration Tools',
        tooltip: 'Administration Tools',
        type: 'aside',
        icon: 'heroicons_outline:shield-check',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];


export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/dashboard',
    },
    {
        id: 'module.passengers',
        title: 'Passengers',
        tooltip: 'Passengers',
        type: 'basic',
        icon: 'heroicons_outline:identification',
        link : '/passengers/info'
    },
    {
        id: 'module.bookings',
        title: 'Bookings',
        tooltip: 'Bookings',
        type: 'basic',
        icon: 'heroicons_outline:ticket',
        link : '/transactions/bookings'
    },
    {
        id: 'module.stay-bookings',
        title: 'Stay Bookings',
        tooltip: 'Stay Bookings',
        type: 'basic',
        icon: 'heroicons_outline:building-office',
        hidden : () => isStayAdminNavHidden(),
        link : '/travel/stay-bookings'
    },
    {
        id: 'module.cancellation-requests',
        title: 'Cancellation Requests',
        tooltip: 'Cancellation Requests',
        type: 'basic',
        icon: 'heroicons_outline:inbox',
        hidden : () => isStayAdminNavHidden(),
        link : '/travel/cancellation-requests'
    },
    {
        id   : 'module.accounting',
        title: 'Accounting',
        tooltip: 'Accounting',
        type : 'basic',
        icon : 'heroicons_outline:banknotes',
        disabled: true,
        link : '/transactions/bookings'
    },
    {
        id: 'reports',
        title: 'Reports',
        tooltip: 'Unveiling Finances Trends, Analysis, and Recommendations',
        type: 'aside',
        icon    : 'heroicons_outline:arrow-trending-up',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'database',
        title: 'Databases',
        tooltip: 'Databases',
        type: 'aside',
        icon: 'heroicons_outline:circle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'administration',
        title: 'Admin',
        tooltip: 'Administration Tools',
        type: 'aside',
        icon: 'heroicons_outline:shield-check',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
